import { gql } from '@apollo/client'

export default gql(`
query listRoles($filter: TableRoleFilterInput $limit: Int $offset: Int $project: String) {
    listRoles( 
      filter: $filter
      limit: $limit
      offset: $offset
      project: $project
    ){
        totalCount
        items {
          id
          name
          source
        }
      }
}`)
